// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button, Input } from '../../../../components';
import styles from './styles';

const CollectionDetails1 = (props) => {
  const {
    classes,
    onPress,
    onPressLater,
    tradeCustomer,
    setFieldForTradeCustomer,
    orderIdFromAccountPage,
  } = props;

  const text1 = `Please confirm the information below
  and we will be in touch to arrange a collection.`;
  const text2 = `You can visit your order history
  and book your collection later once you have packed all your items.`;

  const [error, setError] = useState(null);

  const isValidData = () => {
    const errorBoxes = 'Number of boxes must be numeric';
    const regex = /^[0-9]+$/;
    if (regex.test(tradeCustomer.boxes)) {
      return true;
    }
    setError(errorBoxes);
    return false;
  };

  const onChangeInput = (value, name) => {
    setError(null);
    setFieldForTradeCustomer(name, value);
  };

  return (
    <div className={classes.container}>
      <p className={classes.text1}>{text1}</p>
      <form className={classes.form} autoComplete={'off'}>
        <Input
          label={'Number of boxes/totes that need collecting?'}
          name={'boxes'}
          value={tradeCustomer.boxes}
          onChange={onChangeInput}
        />
      </form>
      {error && <p className={classes.error}>{error}</p>}
      <Button
        style={error ? classes.buttonWithError : classes.button}
        text={'Book Collection'}
        onPress={() => {
          if (isValidData()) {
            onPress();
          }
        }}
      />
      {!orderIdFromAccountPage && (
        <>
          <Button
            style={classes.secondButton}
            text={'Confirm & Book later'}
            onPress={onPressLater}
            light
          />
          <span className={classes.helperText}>{text2}</span>
        </>
      )}
    </div>
  );
};

CollectionDetails1.propTypes = {
  classes: PropTypes.object,
  onPress: PropTypes.func,
  onPressLater: PropTypes.func,
  tradeCustomer: PropTypes.object,
  setFieldForTradeCustomer: PropTypes.func,
  orderIdFromAccountPage: PropTypes.bool,
};

CollectionDetails1.defaultProps = {
  classes: {},
  onPress: () => { },
  onPressLater: () => { },
  tradeCustomer: {
    boxes: null,
  },
  setFieldForTradeCustomer: () => { },
  orderIdFromAccountPage: null,
};

export default withStyles(styles)(CollectionDetails1);
